import React from "react";
import { Link } from "react-router-dom";

interface BlogBreadcrumbsProps {
  title: string;
  subject: string;
}

const BlogBreadcrumbs: React.FC<BlogBreadcrumbsProps> = ({
  title,
  subject,
}) => {
  return (
    <nav className="mb-8 text-sm" aria-label="Breadcrumb">
      <ol
        className="flex flex-wrap items-center text-white/80"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        <li
          className="flex items-center"
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <Link
            to="/"
            className="hover:text-white transition-colors"
            itemProp="item"
          >
            <span itemProp="name">Home</span>
          </Link>
          <svg
            className="h-4 w-4 mx-2 text-white/50"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
          <meta itemProp="position" content="1" />
        </li>
        <li
          className="flex items-center"
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <Link
            to="/blog"
            className="hover:text-white transition-colors"
            itemProp="item"
          >
            <span itemProp="name">Blog</span>
          </Link>
          <svg
            className="h-4 w-4 mx-2 text-white/50"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
          <meta itemProp="position" content="2" />
        </li>
        <li
          className="flex items-center"
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <Link
            to={`/${subject.toLowerCase().replace(/\s+/g, "-")}`}
            className="hover:text-white transition-colors truncate max-w-[150px] md:max-w-xs"
            itemProp="item"
          >
            <span itemProp="name">{subject}</span>
          </Link>
          <svg
            className="h-4 w-4 mx-2 text-white/50 flex-shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
          <meta itemProp="position" content="3" />
        </li>
        <li
          className="text-white truncate max-w-[180px] md:max-w-xs"
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <span itemProp="name" title={title}>
            {title}
          </span>
          <meta itemProp="position" content="4" />
        </li>
      </ol>
    </nav>
  );
};

export default BlogBreadcrumbs;
